import baustein from "baustein";
import store from "web/redux/store";
import { openOverlay } from "web/redux/ducks/cookie-settings";

export default baustein.register("cookie-settings", {
    setupEvents: function(add) {
        add("click", this.onClick);
    },

    onClick() {
        store.dispatch(openOverlay());
    },
});
